export const LESSEE_COMMON = {
    title: '家庭财产保险附加共同被保险人条款',
    subtitle: '（大地财险）（备-企财）[2011]附69号',
    protocols: [
        {
            list: [
                {  context: '兹经保险合同双方同意，本保险项下的共同被保险人为被保险房屋的所有权人（权利人）或承租人，各被保险人在本保险合同项下的权益仅以各自保险利益为限。' },
                { context: '本附加条款与主条款内容相抵触之处，以本附加条款为准；未尽之处，以主条款为准。' }
            ]
        }
    ]
}